import React, { useState } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'
import { useDownload } from '../../hooks/Download/useDownload'

export default function TravelCategory() {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce('', 400)
  const [page, setPage] = React.useState(1)
  const limit = 45;
  const noOfPages = 100;
  const { getPdfCsvData, pdfCsvData, setPdfCsvData, } = useDownload();
  const tempHeaders = ["allowanceType", "name", "created at"];
  let { data: travelCategory, isLoading } = useQuery(['travel-category', debouncedValue && debouncedValue], () => getAllData('/travel/category', { searchQuery: debouncedValue, page: page, limit: limit, noOfpages: noOfPages }))
  const queryClient = useQueryClient()

  let tmpArr = []
  if (!isLoading && travelCategory?.data?.length > 0) {
    travelCategory.data.map((item) => {
      return tmpArr.push([{ type: 'CHECKBOX', _id: item._id }, { value: item.name }, { value: item.allowanceType?.name },  { value: formatDate(item.createdAt) }])
    })
  }
  React.useEffect(()=> {
  }, [ page])

  React.useEffect(()=>{
    getPdfCsvData('TRAVEL_CATEGORY', { searchQuery: searchQuery } )
  }, [])
  const layoutProps = {
    heading: 'Manage Travel Category',
    url: ROUTES.ADD_TRAVEL_CATEGORY,
    editUrl: 'edit-travel-category/',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    permissionName: "TRAVEL_ALLOWANCE",
    tempHeaders: tempHeaders,
    tempHeaderData: [],
    filename: 'travel_category',
    sampleName: 'travel_category',
    sheetName: 'travel_category',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    setPage,
  }

  const deleteMany = async (ids) => {
    for await (let id of ids) {
      await deleteDocumentById('/travel/category', id)
    }
    queryClient.invalidateQueries('travel-category')
  }
  const handlePageChange = (event, value) => {
    console.log("PAGE", value);
    setPage(value)
  }
  return (
    <CustomTableLayout
      tableHeadings={['Travel Category Name', 'Allowance Type',  'Created At']}
      loading={isLoading}
      tableBody={tmpArr}
      // handleSwitchChange={handleSwitchChange}
      handlePageChange={handlePageChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        deleteMany(val)
        setSelected([])
      }}
    />
  )
}
